
import React, { useEffect } from "react";
import { useHistoryOperations } from "@/hooks/useHistoryOperations";
import { EntityHistory } from "@/components/common/EntityHistory";

interface CandidateHistoryTabProps {
  candidateId: string;
}

export const CandidateHistoryTab = ({ candidateId }: CandidateHistoryTabProps) => {
  const { history, loading, fetchHistory } = useHistoryOperations('candidate');

  // Fetch history when component mounts
  useEffect(() => {
    if (candidateId) {
      fetchHistory(candidateId);
    }
  }, [candidateId, fetchHistory]);

  return (
    <div>
      <h3 className="text-lg font-semibold mb-4">Candidate History</h3>
      <EntityHistory history={history} loading={loading} />
    </div>
  );
};
